module.exports = __webpack_public_path__ + "img/title-4.79e9d27f.png";